/**
 * API client for Agent-based chat with streaming support
 */

import { API_BASE_URL, tenantHeaders } from './api';

export interface ImageAttachment {
  data_url: string;
  source_page?: number;
  mime_type?: string;
}

export interface AgentChatRequest {
  query: string;
  current_page: number;
  session_id: string;
  model?: string;
  images?: ImageAttachment[];
}

/**
 * Stream agent chat with tool status updates
 * Returns a ReadableStream that emits SSE events
 *
 * @deprecated bookId parameter is deprecated. The book context is determined by the session.
 */
export const streamAgentChat = async (
  bookId: string,
  request: AgentChatRequest
): Promise<ReadableStream> => {
  const response = await fetch(`${API_BASE_URL}/api/agent-chat/chat`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
      ...tenantHeaders(),
    },
    body: JSON.stringify(request)
  });

  if (!response.ok) throw new Error('Agent chat failed');
  if (!response.body) throw new Error('No response body');

  return response.body;
};

